import { render, staticRenderFns } from "./billappdetail.vue?vue&type=template&id=c82acf30&scoped=true"
import script from "./billappdetail.vue?vue&type=script&lang=js"
export * from "./billappdetail.vue?vue&type=script&lang=js"
import style0 from "./billappdetail.vue?vue&type=style&index=0&id=c82acf30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82acf30",
  null
  
)

export default component.exports